import React from "react"
import {
  SizeGuideSection 
} from "../size-guide-section"

const tableData = {
  title: "Kids' PVC Waders",
  headers: [
    [
      {
        content: "PVC Waders",
        colSpan: 6,
      },
    ],
    [
      {
        content: "Wader Size",
        rowSpan: 2,
      },
      {
        content: "Shoes Size",
        rowSpan: 2,
      },
      {
        content: "Total Length(In)",
        rowSpan: 2,
      },
      {
        content: "Inseam(In)",
        rowSpan: 2,
      },
      {
        content: "Chest(In)",
        rowSpan: 2,
      },
      {
        content: "Hip(In)",
        rowSpan: 2,
      },
    ],
  ],
  data: [
    [
      {
        content: "2/3T",
      },
      {
        content: "9T",
      },
      {
        content: "30",
      },
      {
        content: "17.5",
      },
      {
        content: "30",
      },
      {
        content: "30",
      },
    ],
    [
      {
        content: "4/5",
      },
      {
        content: "12",
      },
      {
        content: "33",
      },
      {
        content: "19.5",
      },
      {
        content: "31",
      },
      {
        content: "31",
      },
    ],
    [
      {
        content: "6/7",
      },
      {
        content: "2",
      },
      {
        content: "36",
      },
      {
        content: "21.5",
      },
      {
        content: "33",
      },
      {
        content: "33",
      },
    ],
    [
      {
        content: "8/9",
      },
      {
        content: "4",
      },
      {
        content: "40",
      },
      {
        content: "24.5",
      },
      {
        content: "35",
      },
      {
        content: "35",
      },
    ],
    [
      {
        content: "10/11",
      },
      {
        content: "6",
      },
      {
        content: "44",
      },
      {
        content: "27.5",
      },
      {
        content: "37",
      },
      {
        content: "37",
      },
    ],
    [
      {
        content: "12/13",
      },
      {
        content: "8",
      },
      {
        content: "48",
      },
      {
        content: "30.5",
      },
      {
        content: "39",
      },
      {
        content: "39",
      },
    ],
    [
      {
        content: "14/15",
      },
      {
        content: "10",
      },
      {
        content: "51",
      },
      {
        content: "32.5",
      },
      {
        content: "41",
      },
      {
        content: "41",
      },
    ],
  ],
}

export const KidsPvcWader = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='PVC Waders'
    tableData={tableData}
    className={className}
  />
}
